import { colors } from './semantic-color-tokens';

const svgDotted = `
<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="2" fill="${colors.transparent5}"/>
        </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#dots)"/>
</svg>`;

const dotted = `url("data:image/svg+xml,${encodeURIComponent(svgDotted)}")`;

export const backgroundTokens = {
  dotted,
};
